import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
	from { opacity: 0; }
	to   { opacity: 1; }
`;

const popIn = keyframes`
	from { opacity: 0; transform: translateY(8px) scale(0.98); }
	to   { opacity: 1; transform: translateY(0) scale(1); }
`;

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
	padding: 20px;
	animation: ${fadeIn} 0.15s ease-out;
`;

export const Card = styled.div`
	background: var(--punchup-color-bg);
	border-radius: var(--punchup-radius-lg);
	box-shadow: var(--punchup-shadow-md);
	width: 100%;
	max-width: 420px;
	padding: 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	animation: ${popIn} 0.18s ease-out;
	font-family: var(--punchup-font-family);
	/* When embedded, the card is capped to the visible band (inline max-height:100% via
	   useIframeDialogClamp); this lets a tall card scroll internally instead of clipping its buttons. */
	overflow-y: auto;
`;

const variantStyles = {
	success: css`
		background: rgba(16, 185, 129, 0.12);
		color: var(--punchup-color-status-success);
	`,
	danger: css`
		background: var(--punchup-color-destructive-tint);
		color: var(--punchup-color-destructive);
	`,
	warning: css`
		background: var(--punchup-color-warning-bg);
		color: var(--punchup-color-warning);
	`,
	info: css`
		background: var(--punchup-color-primary-tint);
		color: var(--punchup-color-primary);
	`,
};

export type DialogVariant = keyof typeof variantStyles;

export const IconBadge = styled.div<{ variant: DialogVariant }>`
	width: 44px;
	height: 44px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	${(p) => variantStyles[p.variant]}
`;

export const Title = styled.h2`
	font-size: var(--punchup-font-size-lg);
	font-weight: 600;
	color: var(--punchup-color-text-heading);
	margin: 4px 0 0;
	text-align: center;
`;

export const Description = styled.p`
	font-size: var(--punchup-font-size-sm);
	color: var(--punchup-color-text-secondary);
	margin: 0;
	text-align: center;
	line-height: 1.5;
	max-width: 320px;
`;

export const Actions = styled.div`
	display: flex;
	gap: 12px;
	width: 100%;
	margin-top: 16px;

	button {
		flex: 1;
	}
`;
